import cn from 'classnames';
import get from 'lodash/get';
import React, { memo } from 'react';

import type IProduct from '@sravni/vitrina/lib/types/IProduct';
import { Wysiwyg } from '@sravni/vitrina-components';

import type ITabDetail from '../../../../interfaces/ITabDetail';
import { Content } from '../../../ui/Table/Content';
import { Section } from '../../../ui/Table/Section';
import { Table as TableUi } from '../../../ui/Table/Table';

import style from './Table.module.scss';

interface IProps {
  className?: string;
  config?: ITabDetail;
  product: IProduct;
  isProductPage?: boolean;
  additionalInformation?: string;
}

const Table: React.FC<IProps> = memo((props: IProps) => {
  const {
    className,
    config: { dynamicTable },
    product,
    isProductPage,
    additionalInformation,
  } = props;

  const isDescriptionBlockShow = product.description || product.comment || additionalInformation;

  return (
    <>
      <div className={cn(className, style.wrapperTable)}>
        <TableUi className={style.table} hasBorder={isProductPage}>
          <thead>
          <Section inversion>
            {get(product, dynamicTable.headers).map((title: string) => (
              <Content className={cn(style.titleCol, style.header)} key={title}>
                <span>{title}</span>
              </Content>
            ))}
          </Section>
          </thead>
          <tbody>
          {get(product, dynamicTable.rows).map((row: string[], index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <Section key={index}>
              {row.map((content: string, contentIndex: number) => (
                // eslint-disable-next-line react/no-array-index-key
                <Content key={contentIndex}>{content}</Content>
              ))}
            </Section>
          ))}
          </tbody>
        </TableUi>
      </div>

      {isDescriptionBlockShow && (
        <div className={style.descriptionBlock}>
          {product.description && (
            <div className={style.description}>
              <Wysiwyg content={product.description} />
            </div>
          )}
          {product.comment && (
            <div className={style.comment}>
              <Wysiwyg content={product.comment} />
            </div>
          )}
          {additionalInformation && (
            <div className={style.additionalInformation}>
              <Wysiwyg content={additionalInformation} />
            </div>
          )}
        </div>
      )}
    </>
  );
});

export default Table;
